@if (admin) {
<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>dns</mat-icon></div>
      <h4>{{ formMode }} Application</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Application Name</mat-label>
        <input matInput formControlName="application_name"
               placeholder="Enter application name"
               [readonly]="editApplication" />
        @if (entryForm.controls['application_name'].hasError('required')) {
          <mat-error>Application Name is required</mat-error>
        }
        @if (entryForm.controls['application_name'].hasError('cannotContainSpace')) {
          <mat-error>Application Name cannot contain spaces</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
        @if (entryForm.controls['Description'].hasError('required')) {
          <mat-error>Description is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (editApplication) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
      @if (!application.approved) {
        <button mat-flat-button color="primary" class="modal-action-btn"
                [disabled]="entryForm.invalid"
                (click)="OnApprove()">
          <mat-icon>check_circle</mat-icon> Approve
        </button>
      }
    }
  </div>
</div>
}

@if (!admin) {
<div class="modal-wrapper">
  <div class="modal-header modal-header--custom">
    <div class="modal-header__title">
      <div class="modal-icon"><mat-icon>web_asset</mat-icon></div>
      <h4>{{ formMode }} Application</h4>
    </div>
    <button mat-icon-button class="modal-close-btn" (click)="activeModal.close('close')" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-form-body">
    <form [formGroup]="entryForm" novalidate>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Application Name</mat-label>
        <input matInput formControlName="application_name"
               placeholder="Enter application name"
               [readonly]="editApplication" />
        @if (entryForm.controls['application_name'].hasError('required')) {
          <mat-error>Application Name is required</mat-error>
        }
        @if (entryForm.controls['application_name'].hasError('cannotContainSpace')) {
          <mat-error>Application Name cannot contain spaces</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" placeholder="Enter description" />
        @if (entryForm.controls['Description'].hasError('required')) {
          <mat-error>Description is required</mat-error>
        }
      </mat-form-field>
    </form>
  </div>

  <div class="modal-footer modal-footer--custom">
    @if (!editApplication) {
      <button mat-flat-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="onCreate()">
        <mat-icon>add</mat-icon> Create
      </button>
    }
    @if (approve) {
      <button mat-stroked-button color="primary" class="modal-action-btn"
              [disabled]="entryForm.invalid || !editApplication"
              (click)="view()">
        <mat-icon>open_in_new</mat-icon> View
      </button>
    }
    @if (editApplication) {
      <button mat-stroked-button color="warn" class="modal-action-btn"
              [disabled]="entryForm.invalid"
              (click)="openConfirmModal('Are you sure you want to Delete?')">
        <mat-icon>delete</mat-icon> Delete
      </button>
    }
  </div>
</div>
}
